import React from 'react';
import { Item , Tab, Table } from 'semantic-ui-react'
import {Link} from 'react-router-dom';
import styled from "styled-components";
import ReactToExcel from 'react-html-table-to-excel'

const currentCalendarYear = () => new Date().getFullYear().toString();

export const renderPanes = (events, isSignedIn,currentMonth) => {

    const panes = [
      {
          menuItem: 'Games This Month: ' + currentMonth,
            render: () => <Tab.Pane>
                            <div className="ui celled list">{renderCurrentMonthList(currentMonth, events, isSignedIn)} </div>
                        </Tab.Pane> },
      {
            menuItem: 'Games Open For Registration: ',
            render: () => <Tab.Pane>
                            <div className="ui celled list">{renderRegistrationList(events, isSignedIn)} </div>
                          </Tab.Pane> },
      {
            menuItem: 'Games This Year: '+currentCalendarYear(),
            render: () => <Tab.Pane>
                            <div className="ui celled list">{renderCurrentYearList(events, isSignedIn)} </div>
                          </Tab.Pane> },
      {
            menuItem: 'All Games',
            render: () => <Tab.Pane>
                                <div className="ui celled list">{renderFullList(events,isSignedIn)} </div>
                          </Tab.Pane> },
      {
            menuItem: 'Export To Excel: ',
            render: () => <Tab.Pane>
                            <div className="ui celled list">{renderPrintList(events)} </div>
                        </Tab.Pane> },
    ]
    return <Tab menu={{ pointing: true }} panes={panes} />;
  }

export const shortenUrl= (url) => {
    if(url.length > 30) {
      return url.substring(0,30)+"...";
    }
    return url;

  }

  const renderAdmin = (event, isSignedIn) => {
    if(isSignedIn){
      return (
        <div className="right floated content">
          <Link
            to={`/events/hands/${event.event_id}/${event.event_date}`}
            className="ui positive button primary mini"
          >
            Upload Hands
          </Link>
          <Link
            to={`/events/edit/${event.event_id}/${event.event_date}`}
            className="ui negative button primary mini"
          >
            Edit or Remove
          </Link>
          <Link
            to={`/events/results/${event.event_id}/${event.event_date}`}
            className="ui positive button primary mini"
          >
            Upload Results
          </Link>
          <Link
            to={`/events/image/${event.event_id}/${event.event_date}`}
            className="ui positive button primary mini"
          >
            Upload Image
          </Link>
          <Link
            to={`/registered/${event.event_id}/${event.event_date}`}
            className="ui button primary mini"
          >
            Registered
          </Link>
          <Link
            to={`/events/winners/${event.event_id}/${event.event_date}`}
            className="ui positive button primary mini"
          >
            Winners
          </Link>
        </div>
      );
    }
  }

 const renderStatus = (x) => {
   if(x.event_activation_status === 'deactivated'){
     return <StyledClubSpanAlert><strong>Status:{x.event_activation_status}</strong></StyledClubSpanAlert>
   }
   else
    return <StyledClubSpan>Status:{x.event_activation_status}</StyledClubSpan>
 }

 const renderListItem =(x) =>{
    return (
      <Item>
      <Item.Content>
      <StyledWrapper>
        <StyledTitle>{x.event_year}-{x.event_month}-{x.event_day} | <strong>{x.event_name}</strong></StyledTitle>
         <StyledMeta>   {x.event_location} |</StyledMeta>
         {renderStatus(x)}
      </StyledWrapper>
    </Item.Content>
  </Item>
    );
  }

  const renderPrintList = (events) => {
     return(
      <React.Fragment>
      <ReactToExcel
        table = 'gamesTable'
        filename ='BridgeMateGames'
        sheet='Games'
        buttonText='Export all games to Excel'
      />
      <Table celled id='gamesTable'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>#</Table.HeaderCell>
          <Table.HeaderCell>Year</Table.HeaderCell>
          <Table.HeaderCell>Month</Table.HeaderCell>
          <Table.HeaderCell>Day</Table.HeaderCell>
          <Table.HeaderCell>Club</Table.HeaderCell>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Location</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {renderPrintListRow(events)}
      </Table.Body>
      </Table>
      </React.Fragment>
     );
  }

  const renderPrintListRow = (events) => {
    return events.map((x, index) => {
      return (
        <Table.Row>
        <Table.Cell>{index+1}</Table.Cell>
        <Table.Cell>
        {x.event_year}
        </Table.Cell>
        <Table.Cell>{x.event_month}</Table.Cell>
        <Table.Cell>{x.event_day}</Table.Cell>
        <Table.Cell>{x.event_club}</Table.Cell>
        <Table.Cell>{x.event_name}</Table.Cell>
        <Table.Cell>{x.event_location}</Table.Cell>
      </Table.Row>
      );
    });
  }

  const renderFullList = (events, isSignedIn) => {
    return events.map((x, index) => {
      return (
         <div role="listitem" key={index} className="item">
          {renderAdmin(x, isSignedIn)}
          {renderListItem(x)}
         </div>
      );
    });
  }

  const renderCurrentYearList = (events, isSignedIn) => {
    return events.filter(x => x.event_year === currentCalendarYear()).map((x, index) => {
      return (
         <div role="listitem" key={index} className="item">
          {renderAdmin(x, isSignedIn)}
          {renderListItem(x)}
         </div>
      );
    });
  }

  const renderRegistrationList = (events, isSignedIn) => {
    return events.filter(x => x.event_registration === "opened").map((x, index) => {
      return (
         <div role="listitem" key={index} className="item">
          {renderAdmin(x, isSignedIn)}
          {renderListItem(x)}
         </div>
      );
    });
  }

  const renderCurrentMonthList = (currentMonth, events, isSignedIn) => {
    return events.filter(x =>  x.event_year === currentCalendarYear()).filter(x => x.event_month === currentMonth).map((x, index) => {
      return (
         <div role="listitem" key={index} className="item">
          {renderAdmin(x, isSignedIn)}
          {renderListItem(x)}
         </div>
      );
    });
  }

  const StyledTitle = styled.h3`
 font-size: 18px;
    font-weight: 300;
    line-height: 1;

`;

const StyledWrapper = styled.section`
  line-height: 1;
  padding: 0.5em;`
;

const StyledMeta = styled.span`
  color: #007791;
  font-weight: 400;
  cursor: pointer;
  font-family: open sans,helvetica neue,Helvetica,Arial,sans-serif;
  font-size: 15px;
  line-height: 1;
`;


const StyledClubSpan = styled.span`
  color: #008000;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
`;

const StyledClubSpanAlert = styled.span`
  color: #bb1919;
  font-size: 15px;
  font-weight: 400;
  line-height: 1;
`;